export default {
  data: {
    isAgree: true,
    account: "",
    password: "",
  },
  rule: {
    account: {
      type: "reg",
      rule: /^[a-zA-Z\d]{6,16}$/,
      message: "登录账号必须是6-16位的字母或数字",
    },
    password: {
      type: "password",
      message: "登录密码不合法,6-16位必须含字母",
    },
  },
};
